module.exports = __webpack_public_path__ + "img/CheynShmuelShmidman.b112014e.png";